export const textLang: any = {
    jp: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'キャンペーンページを共有することで、再チェックインの機会を獲得できます。',
        titleShare: 'シェア',
    },
    us: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'You will get a chance for a make-up check-in by sharing the event page.',
        titleShare: 'SHARE',
    },
    ca: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'You will get a chance for a make-up check-in by sharing the event page.',
        titleShare: 'SHARE',
    },
    au: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'You will get a chance for a make-up check-in by sharing the event page.',
        titleShare: 'SHARE',
    },
    eu: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'You will get a chance for a make-up check-in by sharing the event page.',
        titleShare: 'SHARE',
    },
    uk: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'You will get a chance for a make-up check-in by sharing the event page.',
        titleShare: 'SHARE',
    },
    de: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'Sie haben die Möglichkeit, sich für einen Wiederherstellungs-Check-in nach X Sekunden Surfen auf der Aktionsseite erneut einzuchecken.',
        titleShare: 'TEILEN',
    },
    es: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'Tendrás la oportunidad de recuperar visitas si compartes la página del evento.',
        titleShare: 'COMPARTIR',
    },
    fr: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: `Vous pourrez récupérer une confirmation de présence manquée si vous partagez la page de l'événement.`,
        titleShare: 'PARTAGER',
    },
    it: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'Se condividi la pagina dell’evento, avrai l’opportunità di recuperare un check-in mancato.',
        titleShare: 'CONDIVIDERE',
    },
    kr: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: '이벤트 페이지를 공유하면 체크인 보충 기회를 얻을 수 있습니다.',
        titleShare: '공유하다',
    },
    za: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'You will get a chance for a make-up check-in by sharing the event page.',
        titleShare: '',
    },
    br: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TikTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'Você terá a chance de fazer um check-in de compensação ao compartilhar a página do evento.',
        titleShare: 'COMPARTILHAR',
    },
    mx: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TikTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'Comparte la página de eventos para tener la posibilidad de obtener un registro de recuperación.',
        titleShare: 'COMPARTIR',
    },
    ph: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'You will get a chance for a make-up check-in by sharing the event page.',
        titleShare: 'SHARE',
    },
    nl: {
        Instagram: 'Instagram',
        Facebook: 'Facebook',
        Youtube: 'Youtube',
        TitTok: 'TitTok',
        LINE: 'LINE',
        X: 'X',
        Kakoo: 'Kakoo',
        desc: 'U krijgt de kans voor een compensatie check-in door de evenementpagina te delen.',
        titleShare: 'DELEN',
    },
};
